import React from 'react';
import { useIntl } from 'umi';


export type IntlMessageProps = {
  id: string;
  msg?: string;
  params?: Record<string, string | number>;
};

const IntlMessage: React.FC<IntlMessageProps> = ({ id, msg, params }) => {
  const intl = useIntl();
  const c = window.$tc('', intl.formatMessage);
  return <span>{c(id, msg, params)}</span>;
};

export default IntlMessage;
